import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { Alert, Container, Snackbar, Stack } from '@mui/material';
import useAuthToken from '../../hooks/getUserData';
import { getTags } from '../../api/api-middleware';
import ListTags from '../../components/affiliate-tags/ListTags';
import Loading from '../../components/Loading/loading';

const AffiliateTagsPage = () => {
  const [error, setError] = useState(null);
  const token = useAuthToken();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const fetchData = async () => {
    try {
      if (token) {
        setLoading(true);
        const response = await getTags(token);

        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        setItems(data?.rows || []);
        setError(null);
      }
    } catch (error) {
      setError(error.message || 'An error occurred while fetching tags');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchData(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DashboardLayout>
      <Container maxWidth="xl">
        <Stack spacing={2}>
          {error ? (
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          ) : (
            <>
              <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}>
                <Alert severity="success" sx={{ width: '100%' }}>
                  {snackbarMessage}
                </Alert>
              </Snackbar>

              {loading ? (
                <Loading />
              ) : (
                <ListTags
                  loading={loading}
                  setSnackbarOpen={setSnackbarOpen}
                  setSnackbarMessage={setSnackbarMessage}
                  fetchData={fetchData}
                  setError={setError}
                  token={token}
                  data={
                    (items &&
                      items.map((item, index) => ({
                        ...item,
                        sno: index + 1,
                      }))) ||
                    []
                  }
                />
              )}
            </>
          )}
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default AffiliateTagsPage;
